export default __webpack_public_path__ + "static/media/farm-MIVA-SYMM.15e99cd7.svg";